// Render Prop

import React, { Component } from 'react';
import { Redirect } from 'react-router';

import { Label, Input } from 'reactstrap';
import TableWidget from "../../widgets/TableWidget";

export class SelectSupervisor extends Component {
    static displayName = SelectSupervisor.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            selectedEmployer: false,
            selectedSupervisor: false,
            employerFilterText: "",
            supervisorFilterText: ""
        };

        this.props.store.updateBanner("Update Supervisor");

        this.handleEmployerFilterChange = this.handleEmployerFilterChange.bind(this);
        this.handleSupervisorFilterChange = this.handleSupervisorFilterChange.bind(this);
        this.selectSupervisor = this.selectSupervisor.bind(this);
        this.dataFilters = this.dataFilters.bind(this);

        this.supervisorTable = this.supervisorTable.bind(this);
        this.formatSupervisors = this.formatSupervisors.bind(this);

        
    }


    async handleEmployerFilterChange(event) {
        await this.setState({ employerFilterText: event.target.value });
    }

    async handleSupervisorFilterChange(event) {
        await this.setState({ supervisorFilterText: event.target.value });
    }

    selectSupervisor(e) {
        const supervisorId = e.target.value;
        this.setState({ selectedSupervisor: supervisorId })
    }

    dataFilters() {
        return (
            <React.Fragment>
                <div className="col-12 col-md-6">
                    <Label for="supervisorFilter">Filter By Supervisor Name</Label>
                    <Input placeHolder="Supervisor Name..." type="text" id="supervisorFilter" value={this.state.supervisorFilterText} onChange={this.handleSupervisorFilterChange} />
                </div>
                <div className="col-12 col-md-6">
                    <Label for="employerFilter">Filter By Employer Name</Label>
                    <Input placeHolder="Employer Name..." type="text" id="employerFilter" value={this.state.employerFilterText} onChange={this.handleEmployerFilterChange} />
                </div>
            </React.Fragment>
        )
    }


    render() {

        if (this.state.selectedSupervisor == false) {
            return (
                <div>
                    <div className="row">
                        {this.dataFilters()}
                    </div>
                    <div className="row">
                        {this.supervisorTable()}
                    </div>
                </div>
            )
        }
        else {
            return (<Redirect push to={"/staff/Supervisor/" + this.state.selectedSupervisor} />);
        }
    }


    createHeadings() {
        //Creates the headings for the react-table


        const leftAlignCellProps = (state, rowInfo, column) => {
            return {
                style: {
                    textAlign: "right"
                }
            };
        }

        const columns =
            [
                {
                    Header: "", accessor: "col1",
                    Cell: (props) => (
                        <button className="btn btn-light" value={props.cell.value} onClick={this.selectSupervisor}>
                            Edit
                        </button>
                    ),
                    props: {
                        colspan: "1", style: { width: "10%", borderBottom: "3px solid white" }
                    }
                },
                { Header: "Name", accessor: "col2", props: { colSpan: "1", style: { width: "20%" } } },
                { Header: "Email", accessor: "col3", props: { colSpan: "1", style: { width: "20%" } } },
                {
                    Header: "Designation", accessor: "col4", props: { colSpan: "1", style: { width: "10%" } }
                },
                {
                    Header: "Employer", accessor: "col5", props: { colSpan: "1", style: { width: "30%" } },
                },
                {
                    Header: "Accounts", accessor: "col6", props: { colSpan: "1", style: { width: "10%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                }
            ];

        return columns;
    }

    formatSupervisors(supervisors) {
        //format supervisor data for the react-table
        const data = supervisors.map( (supervisor) => {
            let employer = this.props.store.employers.getById(supervisor.id);

            return {
                col1: supervisor.id,
                col2: supervisor.name,
                col3: supervisor.email,
                col4: supervisor.designation,
                col5: supervisor.employerName,
                col6: employer != null ? employer.accountIds.length : 0
            }
        });

        return data;

    }

    supervisorTable() {
        let supervisors = this.props.store.supervisors.collection;


        if (this.state.employerFilterText || this.state.supervisorFilterText) {
            /* Filter out any employers not matching the filter  */
            supervisors = supervisors.filter((supervisor) => {
                return (
                    supervisor.employerName.toLowerCase().includes(this.state.employerFilterText.toLowerCase()) &&
                    supervisor.name.toLowerCase().includes(this.state.supervisorFilterText.toLowerCase())
                )
            });
        };

        supervisors.sort((a, b) => {
            if (a.name > b.name) {
                return 1
            }
            else if (b.name > a.name) {
                return -1
            }
            return 0;
        });


        const columns = this.createHeadings();
        const data = this.formatSupervisors(supervisors);


        return (
            <TableWidget
                tableProps={{ style: "mt-4" }}
                headerGroupProps={{}}
                rowProps={{}}
                columns={columns}
                data={data} />
        );        
    }

}
